import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Channel } from '../../models/channel.model';

export const loadChannel = createAction('[Channel] Load Channel');

export const loadChannelSuccess = createAction(
  '[Channel] Load Channel Success',
  props<{ channel: Channel | null }>(),
);
export const loadChannelFailure = createAction(
  '[Channel] Load Channel Failure',
  props<{ error: any }>(),
);

export const createChannel = createAction(
  '[Channel] Create Channel',
  props<{ channel: Channel }>(),
);
export const createChannelSuccess = createAction(
  '[Channel] Create Channel Success',
  props<{ channel: Channel }>(),
);
export const createChannelFailure = createAction(
  '[Channel] Create Channel Failure',
  props<{ error: any }>(),
);

export const verifyChannelName = createAction(
  '[Channel] Verify Channel Name',
  props<{ uid: string }>(),
);
export const verifyChannelNameSuccess = createAction(
  '[Channel] Verify Channel Name Success',
);
export const verifyChannelNameFailure = createAction(
  '[Channel] Verify Channel Name Failure',
);

export const updateChannelImage = createAction(
  '[Channel] Update Channel Image',
  props<{ channel: Channel; image: File }>(),
);

export const channelPresignedUrl = createAction(
  '[Channel] Channel Presigned Image Url',
  props<{ url: string; image: File }>(),
);

export const updateChannel = createAction(
  '[Channel] Update Channel',
  props<{ channel: Channel }>(),
);
export const updateChannelSuccess = createAction(
  '[Channel] Update Channel Success',
  props<{ channel: Channel }>(),
);
export const updateChannelFailure = createAction(
  '[Channel] Update Channel Failure',
  props<{ error: AppExceptionModel }>(),
);

export const updateStatus = createAction(
  '[Channel] Update Status',
  props<{ status: string }>(),
);

export const deleteChannel = createAction(
  '[Channel] Delete Channel',
  props<{ id: string }>(),
);

export const deleteChannelSuccess = createAction('[Channel] Delete Channel');

export const deleteChannelFailure = createAction(
  '[Channel] Delete Channel',
  props<{ error: AppExceptionModel }>(),
);

export const clear = createAction('[Channel] Clear Channel');
